import styled, { css } from 'styled-components';

import { media } from '@ovpn-ui/styles';

type Props = { $show: boolean };

const showHide = (props: Props) => {
    const [icon, search] = props.$show ? ['none', 'block'] : ['block', 'none'];

    return css`
        .ovpn-icon-button {
            display: ${icon};
        }

        .ovpn-input-parent {
            display: ${search};
        }
    `;
};

export const Wrapper = styled.div<Props>`
    position: relative;

    width: 100%;
    max-width: 512px;

    ${showHide};

    ${media.SM`
        .ovpn-icon-button {
            display: none;
        }

        max-width: 100%;
        
        .ovpn-input-parent {
            display: block;
            max-width: 100%;
        }
    `}
`;

export const IconsContainer = styled.div`
    display: flex;
    align-items: center;
    width: 48px;

    & > svg {
        margin-left: auto;

        cursor: pointer;
    }
`;
